/**
 * Create FieldController
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

angular.module('flsControllers').controller('FieldController', ['$scope','$window','RepProfile', '$http', function($scope, $window, RepProfile, $http){
  /**
   * Initial State of Scope
   */
  $scope.reps     = [];
  $scope.results  = false;

  // SearchForm
  $scope.formData = {
    content_disabled:false,
    scopes:{}
  };


  /**
   * Remote Search for the HCP
   *
   */
  $scope.search = function(p){

    // Form data
    var form = $scope.formData || {};

    // Initial State of FieldProfiles
    $scope.reps = [];

    // Initial Page Number
    form.page = p || 1

    // Disable search form
    form.content_disabled = true;

    // Injuected resource Hcp will handle the search
    RepProfile.get(form, function(response){
      if (response){
        $scope.results  = response.meta || [];

        // Push the item ito the array of HCPs
        $scope.reps     = response.data || [];

        // Enable the form
        $scope.formData.content_disabled = false;
      }
    }, function($error){
        _.each($error.data, function(error){
            $.publish('resource.error', error);
        });
    });
  }


  /**
   * Return the RepProfile to the upper scope, whaever it may be
   *
   * @param  RepProfile    reps
   * @param  string as
   * @return Void
   */
  $scope.pushToParent = function(rep, as){
    $scope.$parent[as] = rep;
  }


  /**
   * Add Rep Registration
   *
   * @param  RepProfile rep
   * @param  string programID
   * @return Void
   */
  $scope.addRepRegistration = function(repObj, programID){

    // Create the merge default
    var defaults = {
      registration_bucket:"FIELD",
      registration_status_id:10,
      profile_id: repObj.id
    };

    var newRegistration = angular.extend(repObj, defaults);

    // CNK: this looks like it was copied line to line from
    $http.post('/handle/program/' + programID + '/registration', newRegistration)
         .then(function(response){
            // Reload window
            $window.location.href = '/handle/program/' + programID + '/closeout';
          }, function(response){
            // failure callback
            $.publish('form.submitted.error', form);
         }
      );
  };

  // init the HCPs on first load
  $scope.reps = $scope.search();
}]);
